import React, { Component } from "react";
import { List } from "@material-ui/core";

// Custom Components
import Comment from "./Comment";
import { _toArray } from "./../../store/actions/commonActions";

class CommentList extends Component {
  state = {
    locallyHiddenComments: new Set()
  };

  sortByDate = comments => {
    if (!comments) {
      return [];
    }
    var sortedData = _toArray(comments);
    sortedData.sort(function(a, b) {
      if (a.date > b.date) return -1;
      if (a.date < b.date) return 1;
      return 0;
    });
    return sortedData;
  };

  handleCommentHide = (commentID) => {
    this.setState(prevState => ({
      locallyHiddenComments: new Set([...prevState.locallyHiddenComments, commentID])
    }));
  };

  render() {
    const { classes, post } = this.props;
    const comments = post.comments ? this.sortByDate(post.comments) : [];
    
    // Filter out both hidden comments and locally hidden comments
    const filteredComments = comments.filter(comment => 
      !comment.hidden && !this.state.locallyHiddenComments.has(comment.commentID)
    );
    
    return (
      <List className={classes.comments}>
        {filteredComments.length > 0 ? (
          filteredComments.map((comment, i) => (
            <Comment
              key={i}
              comment={comment}
              commentID={comment.commentID}
              onCommentHide={this.handleCommentHide}
              {...this.props}
            />
          ))
        ) : (
          <center>No Comments</center>
        )}
      </List>
    );
  }
}

CommentList.propTypes = {};

export default CommentList;
